import type { GroupInfo, GroupMember } from '@/models/group/group-info';

export const GroupRoleMap = {
  0: 'member',
  9: 'manager',
  10: 'admin',
  11: 'superadmin',
};

export function isGroupAdmin(group: Nullable<GroupInfo>): boolean {
  const role = group?.Self?.Role ?? 0;

  return role >= 9;
}

export function isGroupMemberAdmin(members: Nullable<GroupMember[]>, memberId = 0): boolean {
  if (!members) return false;
  return members.some((m) => m.UserID === memberId && m.Role >= 9);
}
